import { render } from "./ViewSettings.vue?vue&type=template&id=975b941e&scoped=true&ts=true"
import script from "./ViewSettings.vue?vue&type=script&lang=ts"
export * from "./ViewSettings.vue?vue&type=script&lang=ts"

import "./ViewSettings.vue?vue&type=style&index=0&id=975b941e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-975b941e"]])

export default __exports__